module.exports = __webpack_public_path__ + "static/media/ucon14.4fe7a94c.JPG";